import { RequestResponse } from '../../../../../core/application/http-response/http-response';
import { CacheStorage } from '../../../../../core/application/protocols/cache-storage';
import {
  HttpClient,
  HttpMethod
} from '../../../../../core/application/protocols/http-client';
import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { error, success } from '../../../../../core/domain/either/either';
import { GoogleAuthorization } from '../../domain/models/google-authorization';

export class AuthorizationUrl
  implements ServiceCommand<AuthorizationUrl.Response>
{
  constructor(
    private readonly httpClient: HttpClient<AuthorizationUrl.Response>,
    private readonly cacheStorage: CacheStorage,
    private readonly tokenKey: string,
    private readonly url: string
  ) {}

  async execute(): Promise<ServiceCommand.Response<AuthorizationUrl.Response>> {
    const httpResponse = await this.httpClient.request({
      method: HttpMethod.GET,
      url: this.url,
      queryParams: { client: 'google' }
    });

    const responseOrError = RequestResponse.handle(httpResponse);

    if (responseOrError.isError()) {
      return error(responseOrError.value);
    }
    const response = responseOrError.value.response;
    const { authorizationUrl } = response;
    this.cacheStorage.set(this.tokenKey, authorizationUrl);

    return success(response);
  }
}

export namespace AuthorizationUrl {
  export type Response = GoogleAuthorization;
}
